// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-ic-download[data-v-7607bf51]::before{font-size:1.125rem;line-height:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
